import { Injectable } from '@angular/core';
import { ActivityCategory } from '@wilson/interfaces';

type SelectedActivityCategoryTable = {
  [key in string]?: ActivityCategory;
};

@Injectable({
  providedIn: 'root',
})
export class ActivityCategorySelectionService {
  public computeListToUpdate(
    originalList: ActivityCategory[],
    newList: ActivityCategory[],
  ): {
    unselectedList: ActivityCategory[];
    selectedList: ActivityCategory[];
  } {
    const originalTable = this.transformToTable(originalList);
    const newTable = this.transformToTable(newList);

    const unselectedList: ActivityCategory[] = originalList
      .filter((category: ActivityCategory) => {
        return !newTable[category.id as string];
      })
      .map((category) => ({
        ...category,
        isEnabled: false,
      }));

    const selectedList: ActivityCategory[] = newList
      .filter((category: ActivityCategory) => {
        return !originalTable[category.id as string];
      })
      .map((category) => ({
        ...category,
        isEnabled: true,
      }));

    return {
      unselectedList,
      selectedList,
    };
  }

  public removeFromList(
    list: ActivityCategory[],
    itemsToRemove: ActivityCategory[],
  ): ActivityCategory[] {
    return list.filter((selectedCategory) => {
      const matchedIndex = itemsToRemove.findIndex(
        (unselectedCategory) => unselectedCategory.id === selectedCategory.id,
      );

      return matchedIndex === -1;
    });
  }

  private transformToTable(
    list: ActivityCategory[],
  ): SelectedActivityCategoryTable {
    return list.reduce(
      (prev: SelectedActivityCategoryTable, curr: ActivityCategory) => {
        prev[curr.id as string] = curr;
        return prev;
      },
      {},
    );
  }
}
